"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryController = void 0;
var immer_1 = require("immer");
var R = __importStar(require("ramda"));
var rxjs_1 = require("rxjs");
var __1 = require("..");
var openapi_1 = require("../../../generated/openapi");
var NQError_1 = require("../NQError");
var localStorage_1 = require("../util/localStorage");
var HistoryController = /** @class */ (function () {
    function HistoryController(logger) {
        var _this = this;
        this.appendStoreNQValues = function (nqValues) {
            _this.appendStoreNQRecord(createNQRecord(nqValues, new Date()));
        };
        this.saveSummarizer = function (nqValues) {
            _this.appendStoreNQValues(nqValues.map(function (v) { return v; }));
            return rxjs_1.EMPTY;
        };
        migrateLocalStorage(logger);
        this.subject = new rxjs_1.BehaviorSubject(decodeFromLocalStorage((0, localStorage_1.getHistory)(), logger));
    }
    HistoryController.prototype.appendStoreNQRecord = function (nqRecord) {
        var newItems = __spreadArray(__spreadArray([], this.subject.value, true), [nqRecord], false);
        this.updateStore(newItems);
    };
    HistoryController.prototype.updateStore = function (newItems) {
        var serialized = serializeToLocalStorage(newItems);
        (0, localStorage_1.setHistory)(serialized);
        this.subject.next(newItems);
    };
    HistoryController.prototype.history = function () {
        return this.subject.asObservable();
    };
    HistoryController.prototype.historyDeleteAll = function () {
        this.updateStore([]);
    };
    HistoryController.prototype.historyDeleteRecord = function (speedtestId) {
        var newItems = this.subject.value.filter(function (v) { return v.prepareResult.init.speedtest.id !== speedtestId; });
        this.updateStore(newItems);
    };
    return HistoryController;
}());
exports.HistoryController = HistoryController;
/* pure */
function createNQRecord(nqValues, date) {
    var record = {
        date: date,
        prepareResult: createNQRecordPrepareResult(findByKind([__1.NQValueKind.PrepareResult], nqValues)),
        benchmarkFinal: findByKind([__1.NQValueKind.BenchmarkFinalAvailable, __1.NQValueKind.BenchmarkFinalDidNotRun], nqValues),
        downloadFinal: findByKind([__1.NQValueKind.DownloadFinal], nqValues),
        uploadFinal: findByKind([__1.NQValueKind.UploadFinal], nqValues),
        pingFinal: findByKind([__1.NQValueKind.PingFinal], nqValues),
        modemFinal: findByKind([__1.NQValueKind.ModemFinal], nqValues),
        hints: findByKind([__1.NQValueKind.Hints], nqValues).hints.map(function (h) { return h.id; }),
    };
    return (0, immer_1.freeze)(record);
}
/**
 * Searches an array for a value of a given selection of kinds and returns it.
 * @kinds array of kinds to choose from
 * @param nqValues values
 * @throws if a value of the given type is not found, an exception is thrown
 * pure
 */
function findByKind(kinds, nqValues) {
    var candidate = nqValues.find(function (v) { return R.includes(v.kind, kinds); });
    if (candidate != undefined) {
        return candidate;
    }
    else {
        throw new NQError_1.NQInternalError(NQError_1.NQInternalErrorCode.MissingNQValueDuringSave, "", JSON.stringify(kinds));
    }
}
/* pure */
function createNQRecordPrepareResult(p) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        init: {
            speedtest: {
                id: p.init.speedtest.id,
            },
            connection: {
                ip: p.init.connection.ip,
                isp: p.init.connection.isp,
                isCustomer: p.init.connection.isCustomer,
                ispFootprint: p.init.connection.ispFootprint,
                isVpnActive: p.init.connection.isVpnActive,
            },
            modem: {
                bookedDownloadSpeedMax: (_a = p.init.modem) === null || _a === void 0 ? void 0 : _a.bookedDownloadSpeedMax,
                bookedDownloadSpeedAvg: (_b = p.init.modem) === null || _b === void 0 ? void 0 : _b.bookedDownloadSpeedAvg,
                bookedDownloadSpeedMin: (_c = p.init.modem) === null || _c === void 0 ? void 0 : _c.bookedDownloadSpeedMin,
                bookedUploadSpeedMax: (_d = p.init.modem) === null || _d === void 0 ? void 0 : _d.bookedUploadSpeedMax,
                bookedUploadSpeedAvg: (_e = p.init.modem) === null || _e === void 0 ? void 0 : _e.bookedUploadSpeedAvg,
                bookedUploadSpeedMin: (_f = p.init.modem) === null || _f === void 0 ? void 0 : _f.bookedUploadSpeedMin,
                provisionedDownloadSpeed: (_g = p.init.modem) === null || _g === void 0 ? void 0 : _g.provisionedDownloadSpeed,
                type: (_h = p.init.modem) === null || _h === void 0 ? void 0 : _h.type,
                name: (_j = p.init.modem) === null || _j === void 0 ? void 0 : _j.name,
                vendor: (_k = p.init.modem) === null || _k === void 0 ? void 0 : _k.vendor,
            },
            cmts: p.init.cmts === null ? null : {
                isModemTestAvailable: p.init.cmts.isModemTestAvailable,
                vendor: p.init.cmts.vendor,
            },
            client: {
                device: p.init.client.device,
                browser: {
                    name: p.init.client.browser.name,
                    version: p.init.client.browser.version,
                    isCurrent: p.init.client.browser.isCurrent,
                }
            },
            communication: {
                modemSwapLink: p.init.communication.modemSwapLink,
                plannedImprovement: p.init.communication.plannedImprovement,
            }
        },
        isIPv6: p.isIPv6,
    };
}
/* pure */
function encodeNQRecord(nqRecord) {
    return (0, immer_1.freeze)({
        version: JsonNQRecordVersion.v7,
        date: nqRecord.date.toISOString(),
        prepareResult: nqRecord.prepareResult,
        benchmarkFinal: nqRecord.benchmarkFinal,
        downloadFinal: {
            speed: nqRecord.downloadFinal.speed,
            jitter: nqRecord.downloadFinal.jitter,
        },
        uploadFinal: {
            speed: nqRecord.uploadFinal.speed,
            jitter: nqRecord.uploadFinal.jitter,
        },
        pingFinal: {
            pingTime: nqRecord.pingFinal.pingTime,
            jitter: nqRecord.pingFinal.jitter,
        },
        modemFinal: nqRecord.modemFinal,
        hints: nqRecord.hints,
    });
}
/* pure */
function decodeFromLocalStorage(data, logger) {
    if (data === null) {
        return [];
    }
    try {
        var deserializedItems = JSON.parse(data);
        if (Array.isArray(deserializedItems)) {
            var items = deserializedItems
                .map(function (v) { return decodeNQRecord(v, logger); })
                .filter(function (v) { return v != null; });
            return items;
        }
    }
    catch (err) {
        return [];
    }
    return [];
}
/* pure */
function serializeToLocalStorage(records) {
    var encodedItems = records.map(encodeNQRecord);
    return JSON.stringify(encodedItems);
}
/* pure */
function decodeNQRecord(value, logger) {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        if (typeof value["version"] === typeof JsonNQRecordVersion.v1) {
            var jsonNQRecord = value;
            if (jsonNQRecord.version === JsonNQRecordVersion.v1 || jsonNQRecord.version === JsonNQRecordVersion.v2) {
                return decodeNQRecordFromV1_V2(jsonNQRecord, logger);
            }
            else if (jsonNQRecord.version === JsonNQRecordVersion.v3 ||
                jsonNQRecord.version === JsonNQRecordVersion.v4 ||
                jsonNQRecord.version === JsonNQRecordVersion.v5 ||
                jsonNQRecord.version === JsonNQRecordVersion.v6 ||
                jsonNQRecord.version === JsonNQRecordVersion.v7) {
                return decodeNQRecordFromV3_V7(jsonNQRecord, logger);
            }
        }
    }
    return null;
}
/* pure */
function decodeConnectionType(connectionType) {
    switch (connectionType) {
        case "wlan24":
            return openapi_1.SnmpResultModelConnectionTypeEnum.Wlan24;
        case "wlan5":
            return openapi_1.SnmpResultModelConnectionTypeEnum.Wlan5;
        case "lan":
            return openapi_1.SnmpResultModelConnectionTypeEnum.Lan;
        case null:
            return null;
    }
}
/* pure */
function decodeModemNotRunReason(reason) {
    switch (reason) {
        case "NotACustomer":
            return __1.ModemNotRunReason.NotACustomer;
        case "NotAvailable":
            return __1.ModemNotRunReason.NotAvailable;
        case "NotNeeded":
            return __1.ModemNotRunReason.NotNeeded;
    }
}
/* pure */
function decodeNQRecordModemFinalV6_V7(value) {
    var modemFinal;
    switch (value.modemFinal.modemFinal.kind) {
        case "ModemFinalAvailable":
            modemFinal = { kind: __1.ModemFinalKind.ModemFinalAvailable, speed: value.modemFinal.modemFinal.speed };
            break;
        case "ModemFinalDidNotRun":
            modemFinal = { kind: __1.ModemFinalKind.ModemFinalDidNotRun, reason: decodeModemNotRunReason(value.modemFinal.modemFinal.reason) };
            break;
        case "ModemFinalFailed":
            modemFinal = { kind: __1.ModemFinalKind.ModemFinalFailed, message: value.modemFinal.modemFinal.message };
            break;
    }
    return {
        kind: __1.NQValueKind.ModemFinal,
        parallelTraffic: value.modemFinal.parallelTraffic,
        connectionType: decodeConnectionType(value.modemFinal.connectionType),
        modemFinal: modemFinal
    };
}
/* pure */
function decodeNQRecordModemFinalV1_V5(value, logger) {
    switch (value.modemFinal.kind) {
        case "ModemFinalAvailable":
            return {
                kind: __1.NQValueKind.ModemFinal,
                parallelTraffic: value.modemFinal.parallelTraffic,
                connectionType: decodeConnectionType(value.modemFinal.connectionType),
                modemFinal: {
                    kind: __1.ModemFinalKind.ModemFinalAvailable,
                    speed: value.modemFinal.speed,
                }
            };
        case "ModemFinalDidNotRun":
            return {
                kind: __1.NQValueKind.ModemFinal,
                parallelTraffic: null,
                connectionType: null,
                modemFinal: {
                    kind: __1.ModemFinalKind.ModemFinalDidNotRun,
                    reason: decodeModemNotRunReason(value.modemFinal.reason)
                }
            };
        case "ModemFinalFailed":
            return {
                kind: __1.NQValueKind.ModemFinal,
                parallelTraffic: null,
                connectionType: null,
                modemFinal: {
                    kind: __1.ModemFinalKind.ModemFinalFailed,
                    message: value.modemFinal.message,
                }
            };
        default:
            logger.warn(value.modemFinal, "Unknown kind for ModemFinal.");
            return null;
    }
    ;
}
/* pure */
function parseDate(dateStr, logger) {
    var date = new Date(dateStr);
    if (isNaN(date.getTime())) {
        logger.info({ dateStr: dateStr }, "During NQRecord parsing, could not parse this string as date.");
        // TODO: Report to sentry
        return null;
    }
    ;
    return date;
}
/* pure */
function decodeBenchmarkFinal(value, logger) {
    switch (value.version) {
        case JsonNQRecordVersion.v1:
            return __assign(__assign({}, value.benchmarkFinal), { kind: __1.NQValueKind.BenchmarkFinalAvailable });
        case JsonNQRecordVersion.v2:
        case JsonNQRecordVersion.v3:
        case JsonNQRecordVersion.v4:
        case JsonNQRecordVersion.v5:
        case JsonNQRecordVersion.v6:
        case JsonNQRecordVersion.v7:
            switch (value.benchmarkFinal.kind) {
                case "BenchmarkFinalAvailable":
                    return __assign(__assign({}, value.benchmarkFinal), { kind: __1.NQValueKind.BenchmarkFinalAvailable });
                case "BenchmarkFinalDidNotRun":
                    return { kind: __1.NQValueKind.BenchmarkFinalDidNotRun };
                default:
                    logger.warn(value.benchmarkFinal, "Unknown kind for record V2: ".concat(value.benchmarkFinal.kind));
                    return null;
            }
        default:
            logger.warn(value, "Unknown version at decodeBenchmarkFinal");
            return null;
    }
}
/* pure */
function decodeNQRecordFromV3_V7(value, logger) {
    var getModemFinal = function () {
        switch (value.version) {
            case JsonNQRecordVersion.v3:
            case JsonNQRecordVersion.v4:
            case JsonNQRecordVersion.v5:
                return decodeNQRecordModemFinalV1_V5(value, logger);
            case JsonNQRecordVersion.v6:
            case JsonNQRecordVersion.v7:
                return decodeNQRecordModemFinalV6_V7(value);
            default:
                logger.warn(value, "Unknown version at decodeNQRecordFromV3_V7");
                return null;
        }
    };
    try {
        var modemFinal = getModemFinal();
        var date = parseDate(value.date, logger);
        var benchmarkFinal = decodeBenchmarkFinal(value, logger);
        if (R.isNil(modemFinal) || R.isNil(date) || R.isNil(benchmarkFinal)) {
            return null;
        }
        var ispFootprint = void 0;
        switch (value.prepareResult.init.connection.ispFootprint) {
            case "UM":
                ispFootprint = openapi_1.ConnectionModelIspFootprintEnum.Um;
                break;
            case "VF":
                ispFootprint = openapi_1.ConnectionModelIspFootprintEnum.Vf;
                break;
            default:
                if (!R.isNil(ispFootprint)) {
                    logger.warn(value.prepareResult.init.connection, "Unknown value for ispFootprint: ".concat(value.prepareResult.init.connection.ispFootprint));
                    return null;
                }
        }
        var deviceType = void 0;
        switch (value.prepareResult.init.client.device.deviceType) {
            case "mobile":
                deviceType = openapi_1.DeviceModelDeviceTypeEnum.Mobile;
                break;
            case "tablet":
                deviceType = openapi_1.DeviceModelDeviceTypeEnum.Tablet;
                break;
            case "desktop":
                deviceType = openapi_1.DeviceModelDeviceTypeEnum.Desktop;
                break;
            case "settop":
                deviceType = openapi_1.DeviceModelDeviceTypeEnum.Settop;
                break;
            case "crawler":
                deviceType = openapi_1.DeviceModelDeviceTypeEnum.Crawler;
                break;
            default:
                if (!R.isNil(deviceType)) {
                    logger.warn(value.prepareResult.init.client.device, "Unknown value for deviceType: ".concat(value.prepareResult.init.client.device.deviceType));
                    return null;
                }
        }
        var prepareResult = __assign(__assign({}, value.prepareResult), { init: __assign(__assign({}, value.prepareResult.init), { modem: value.prepareResult.init.modem === null ? {} : value.prepareResult.init.modem, connection: __assign(__assign({}, value.prepareResult.init.connection), { ispFootprint: ispFootprint }), client: __assign(__assign({}, value.prepareResult.init.client), { device: { deviceType: deviceType } }) }) });
        return (0, immer_1.freeze)({
            date: date,
            prepareResult: prepareResult,
            benchmarkFinal: benchmarkFinal,
            downloadFinal: __assign(__assign({}, value.downloadFinal), { kind: __1.NQValueKind.DownloadFinal }),
            uploadFinal: __assign(__assign({}, value.uploadFinal), { kind: __1.NQValueKind.UploadFinal }),
            pingFinal: __assign(__assign({}, value.pingFinal), { kind: __1.NQValueKind.PingFinal }),
            modemFinal: modemFinal,
            hints: value.hints,
        });
    }
    catch (err) {
        logger.error(err, "Error parsing NQRecord");
        return null;
    }
}
/* pure */
function decodeNQRecordFromV1_V2(value, logger) {
    logger.info(value, "decodeNQRecordFromV1_V2");
    try {
        var modemFinal = decodeNQRecordModemFinalV1_V5(value, logger);
        var date = parseDate(value.date, logger);
        var benchmarkFinal = decodeBenchmarkFinal(value, logger);
        if (R.isNil(modemFinal) || R.isNil(date) || R.isNil(benchmarkFinal)) {
            return null;
        }
        var prepareResult = __assign(__assign({}, value.prepareResult), { init: __assign(__assign({}, value.prepareResult.init), { modem: value.prepareResult.init.modem === null ? {} : value.prepareResult.init.modem, client: __assign(__assign({}, value.prepareResult.init.client), { device: {} }) }) });
        return (0, immer_1.freeze)({
            date: date,
            prepareResult: prepareResult,
            benchmarkFinal: benchmarkFinal,
            downloadFinal: __assign(__assign({}, value.downloadFinal), { kind: __1.NQValueKind.DownloadFinal }),
            uploadFinal: __assign(__assign({}, value.uploadFinal), { kind: __1.NQValueKind.UploadFinal }),
            pingFinal: __assign(__assign({}, value.pingFinal), { kind: __1.NQValueKind.PingFinal }),
            modemFinal: modemFinal,
            hints: null
        });
    }
    catch (err) {
        logger.error(err, "Error parsing NQRecord");
        return null;
    }
}
function migrateLocalStorage(logger) {
    var legacyData = (0, localStorage_1.getHistoryLegacy)();
    if (legacyData === null) {
        return;
    }
    var didMigrate = (0, localStorage_1.getHistoryDidMigrate)();
    if (didMigrate) {
        return;
    }
    var legacyRecords = parseLegacyData(legacyData, logger);
    var modernRecords = decodeFromLocalStorage((0, localStorage_1.getHistory)(), logger);
    (0, localStorage_1.setHistory)(serializeToLocalStorage(legacyRecords.concat(modernRecords)));
    (0, localStorage_1.setHistoryDidMigrate)();
}
/** pure
  @throws - never
*/
function parseLegacyData(data, logger) {
    try {
        var parsed = JSON.parse(data);
        if (!Array.isArray(parsed)) {
            // TODO: Generate Sentry warning
            logger.warn("parseLegacyData: expected array in legacy data but got ".concat(data.substring(0, 20)));
            return [];
        }
        return parsed
            .map(function (v) { return decodeNQRecordFromLegacy(v, logger); })
            .filter(function (v) { return v !== null; });
    }
    catch (err) {
        // TODO: Generate Sentry warning
        logger.warn("parseLegacyData got exception: ".concat(err));
        return [];
    }
}
/* pure */
function decodeNQRecordFromLegacy(value, logger) {
    var _a, _b, _c, _d;
    function isIPv4(ipAddress) {
        var regex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/gm;
        return (regex.exec(ipAddress) !== null);
    }
    function parseDate(date_full, hourStr) {
        // Example date_full value: "24.09.2021"
        var _a = date_full.split(".").map(Number), day = _a[0], month = _a[1], year = _a[2];
        // Example hourStr value: "24.09"
        var _b = hourStr.split(":").map(Number), hour = _b[0], minute = _b[1];
        if (year === undefined || month === undefined || day === undefined || hour === undefined || minute === undefined) {
            return null;
        }
        return new Date(year, month - 1, day, hour, minute);
    }
    function decodeConnectionType(value) {
        if (value.wlan_2dot4) {
            return openapi_1.SnmpResultModelConnectionTypeEnum.Wlan24;
        }
        if (value.wlan_5) {
            return openapi_1.SnmpResultModelConnectionTypeEnum.Wlan5;
        }
        if (value.lan) {
            return openapi_1.SnmpResultModelConnectionTypeEnum.Lan;
        }
        return null;
    }
    try {
        // Validate object form
        if (!(typeof value.downstream_booked === "number" &&
            typeof value.upstream_booked === "number" &&
            typeof value.date_full === "string" &&
            typeof value.hour === "string" &&
            typeof value.speedtest_id === "string" && value.speedtest_id.length > 0 &&
            typeof value.clientIp === "string" &&
            typeof value.isp === "string" &&
            (typeof value.cmtsVendor === "string" || value.cmtsVendor === null || value.cmtsVendor === undefined) &&
            typeof value.downstream === "number" &&
            typeof value.upstream === "number")) {
            // TODO: report to sentry
            return null;
        }
        var isCustomer_1 = (value.downstream_booked > 0) && (value.upstream_booked > 0);
        var modemFinalFunc = function () {
            if (typeof value.downstream_udp === "number" && value.downstream_udp > 0) {
                return {
                    kind: __1.ModemFinalKind.ModemFinalAvailable,
                    speed: value.downstream_udp * 1e6,
                };
            }
            else {
                if (!isCustomer_1) {
                    return {
                        kind: __1.ModemFinalKind.ModemFinalDidNotRun,
                        reason: __1.ModemNotRunReason.NotACustomer,
                    };
                }
                else {
                    if (value.udp_error) {
                        return {
                            kind: __1.ModemFinalKind.ModemFinalFailed,
                            message: null
                        };
                    }
                    else {
                        if (!value.speedtest_ok_download) {
                            return {
                                kind: __1.ModemFinalKind.ModemFinalDidNotRun,
                                reason: __1.ModemNotRunReason.NotAvailable,
                            };
                        }
                        else {
                            return {
                                kind: __1.ModemFinalKind.ModemFinalDidNotRun,
                                reason: __1.ModemNotRunReason.NotNeeded,
                            };
                        }
                    }
                }
            }
        };
        var modemFinal = {
            kind: __1.NQValueKind.ModemFinal,
            parallelTraffic: Boolean(value.parallel),
            connectionType: decodeConnectionType(value),
            modemFinal: modemFinalFunc(),
        };
        var date = parseDate(value.date_full, value.hour);
        if (date === null || isNaN(date.getTime())) {
            logger.warn("Could not parse date: ".concat(value.date_full, " ").concat(value.hour));
            // TODO: Add Sentry warning
            return null;
        }
        ;
        var prepareResult = {
            init: {
                speedtest: {
                    id: value.speedtest_id,
                },
                connection: {
                    ip: value.clientIp,
                    isp: value.isp,
                    isCustomer: isCustomer_1,
                    isVpnActive: value.vpnDetected === undefined ? undefined : Boolean(value.vpnDetected),
                },
                modem: isCustomer_1 ? {
                    bookedDownloadSpeedMax: value.downstream_booked === 0 ? null : value.downstream_booked * 1e6,
                    bookedUploadSpeedMax: value.upstream_booked === 0 ? null : value.upstream_booked * 1e6,
                    name: R.isNil((_a = value.modemType) === null || _a === void 0 ? void 0 : _a.name) ? null : String((_b = value.modemType) === null || _b === void 0 ? void 0 : _b.name),
                    type: R.isNil((_c = value.modemType) === null || _c === void 0 ? void 0 : _c.code) ? null : String((_d = value.modemType) === null || _d === void 0 ? void 0 : _d.code),
                } : {},
                cmts: R.isNil(value.secondStepPossible) ? null : {
                    isModemTestAvailable: Boolean(value.secondStepPossible),
                    vendor: value.cmtsVendor,
                },
                client: {
                    device: {},
                    browser: {
                        name: String(value.browser_name),
                        version: String(value.browser_version),
                        isCurrent: Boolean(value.browser_isCurrent),
                    }
                },
                communication: {}
            },
            isIPv6: !isIPv4(value.clientIp),
        };
        var result = (0, immer_1.freeze)({
            date: date,
            prepareResult: prepareResult,
            benchmarkFinal: {
                kind: __1.NQValueKind.BenchmarkFinalAvailable,
                result1: Number(value.browser_benchmark),
                result2: Number(value.browser_benchmark),
            },
            downloadFinal: {
                kind: __1.NQValueKind.DownloadFinal,
                speed: value.downstream * 1e6,
                jitter: 0
            },
            uploadFinal: {
                kind: __1.NQValueKind.UploadFinal,
                speed: value.upstream * 1e6,
                jitter: 0,
            },
            pingFinal: {
                kind: __1.NQValueKind.PingFinal,
                pingTime: value.ping * 1e-3,
                jitter: value.jitter * 1e-3,
            },
            modemFinal: modemFinal,
            hints: null,
        });
        return result;
    }
    catch (err) {
        // TODO: report warning to Sentry
        logger.warn("Error parsing NQRecord: ".concat(err));
        return null;
    }
}
var JsonNQRecordVersion;
(function (JsonNQRecordVersion) {
    JsonNQRecordVersion[JsonNQRecordVersion["v1"] = 1] = "v1";
    JsonNQRecordVersion[JsonNQRecordVersion["v2"] = 2] = "v2";
    JsonNQRecordVersion[JsonNQRecordVersion["v3"] = 3] = "v3";
    JsonNQRecordVersion[JsonNQRecordVersion["v4"] = 4] = "v4";
    JsonNQRecordVersion[JsonNQRecordVersion["v5"] = 5] = "v5";
    JsonNQRecordVersion[JsonNQRecordVersion["v6"] = 6] = "v6";
    JsonNQRecordVersion[JsonNQRecordVersion["v7"] = 7] = "v7";
})(JsonNQRecordVersion || (JsonNQRecordVersion = {}));
;
//# sourceMappingURL=HistoryController.js.map